import { fetchVehicle } from '@/api/vehicles'
import store from '@/store'

export async function refreshLinkedVehicle() {
  const linkedVehicle = store.getters.vehicle
  if (!linkedVehicle?.id) {
    return
  }

  try {
    const response = await fetchVehicle(linkedVehicle.id)
    store.commit('app.setVehicle', response.data.data)
  } catch (error) {
    // Only clear the link when the vehicle itself is confirmed gone.
    // Any other error (permissions, network, server) is transient and
    // shouldn't wipe a valid link.
    if (error?.response?.status === 404) {
      store.commit('app.setVehicle', null)
    }
  }
}
